// extracted by mini-css-extract-plugin
export default {"buttons":"Checkout_buttons__bvFIu","paystack":"Checkout_paystack__N8MFp","flutterwave":"Checkout_flutterwave__tqxla"};